import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo">
          <img src="/logo.png" alt="DocuAIHub" className="logo-image" />
        </Link>

        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <Link to="/en/pricing" className="nav-link">Pricing</Link>
          <Link to="/en/about" className="nav-link">About</Link>
          <Link to="/en/contact" className="nav-link">Contact Us</Link>
          <Link to="/en/signin" className="nav-link">Sign In</Link>
          <a href="/lp/xbt1l" className="btn-subscribe">Subscribe</a>
        </nav>

        <button 
          className="menu-toggle" 
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;
